module.exports = "/assets/data/58bf6d11558da38d3e9ff45cda718c27-LL57.data.json";